module.exports = __webpack_public_path__ + "static/media/MuliRegular.70e2e885.eot";